import React from 'react';
import { DateTime } from 'luxon';
import sanitizeHtml from 'sanitize-html';
import moment from 'moment';
import { getActivityIcon } from '../../../../utils/get-prospect-icon';
import MasterLog from '../../../../enums/master-log-enum';
import IconAndLog from '../../atoms/icon-and-log';
import { ActivityGroupKey } from '../../organisms/activity/types';
import { getUserTimeZone } from '../../../../utils/user-details';

const getIconForActivity = (key: MasterLog) => getActivityIcon(key);

type ActivityLogEntry = {
  log: string;
  key: MasterLog;
  timestamp?: string;
  _id?: string;
};

type ActivityLogComponentProps = {
  dayText: React.ReactNode;
  groupKey?: ActivityGroupKey;
  activity: ActivityLogEntry[];
};

const formatInlineDayText = (
  groupKey: ActivityGroupKey | undefined,
  groupLabel: string,
  timestamp?: string,
): string => {
  if (!timestamp) {
    return groupLabel;
  }

  if (groupKey === 'today' || groupKey === 'yesterday') {
    return groupLabel;
  }

  return DateTime.fromISO(timestamp).toFormat('ccc, LLL d, yyyy');
};

const ActivityLogComponent: React.FC<ActivityLogComponentProps> = ({
  dayText,
  activity,
  groupKey,
}) => {
  const groupLabel = React.Children.toArray(dayText).join('');
  const userTimezone = getUserTimeZone();

  return (
    <div className="d-flex flex-column gap-16 log-activity-new">
      <span className="day-text">{dayText}</span>

      {activity.map(({ log, key, timestamp, _id }) => {
        const parsed = sanitizeHtml(log, {
          allowedTags: [
            'b',
            'i',
            'em',
            'strong',
            'a',
            'br',
            'img',
            'div',
            'span',
            'p',
          ],
          allowedAttributes: {
            a: ['href', 'target'],
            img: ['src', 'height'],
            div: ['class'],
            strong: ['class'],
            span: ['class'],
          },
        });
        const date = moment(timestamp).tz(userTimezone);
        return (
          <IconAndLog
            key={_id || key}
            icon={getIconForActivity(key)}
            log={parsed}
            type={key}
            dayText={formatInlineDayText(
              groupKey,
              groupLabel,
              date ? date.format() : timestamp,
            )}
            timestamp={date ? date.format() : timestamp}
            timezone={userTimezone}
          />
        );
      })}
    </div>
  );
};

export default ActivityLogComponent;
